<template>
  <div class="container-fluid">

<!--    modals start-->
    <div class="modal fade" id="accPaymentsModalVisible" tabindex="-1" aria-labelledby="payoutsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="payoutsModalLabel">Sales</h5>


            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

          </div>
          <div class="modal-body">
            <span v-if="fsales.length > 0">{{ fsales[0].date }}</span>
            <vue-good-table :search-options="{ enabled: true }" :columns="modalViewAccountspayments" :rows="fsales"
                            :pagination-options="pageOptions" theme="polar-bear" styleClass="vgt-table condensed">
              <template slot="table-row" slot-scope="props">
                <!-- Customize the content of each row if needed -->
                <!-- ... (unchanged code) ... -->
              </template>
            </vue-good-table>                  </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="cashToSafeModalVisible" tabindex="-1" aria-labelledby="accPaymentsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="payoutsModalLabel">Sold</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <vue-good-table :search-options="{ enabled: true }" :columns="modalViewCashToSale" :rows="fsold"
                            :pagination-options="pageOptions" theme="polar-bear" styleClass="vgt-table condensed">
              <template slot="table-row" slot-scope="props">
                <!-- Customize the content of each row if needed -->
                <!-- ... (unchanged code) ... -->
              </template>
            </vue-good-table>                  </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="voidsModalVisible" tabindex="-1" aria-labelledby="cashToSafeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="payoutsModalLabel">Voids</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <vue-good-table :search-options="{ enabled: true }" :columns="modalViewVoids" :rows="fvoids"
                            :pagination-options="pageOptions" theme="polar-bear" styleClass="vgt-table condensed">
              <template slot="table-row" slot-scope="props">

              </template>
            </vue-good-table>                  </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="AccountspayVisible" tabindex="-1" aria-labelledby="cashToSafeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="payoutsModalLabel">Account pay</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <vue-good-table :search-options="{ enabled: true }" :columns="modalAccountspayVisible" :rows="fAccountsPay"
                            :pagination-options="pageOptions" theme="polar-bear" styleClass="vgt-table condensed">
              <template slot="table-row" slot-scope="props">

              </template>
            </vue-good-table>                  </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="refunModalVisible" tabindex="-1" aria-labelledby="creditsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="payoutsModalLabel">Refunds</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <vue-good-table :search-options="{ enabled: true }" :columns="modalViewRefunds" :rows="frefunds"
                            :pagination-options="pageOptions" theme="polar-bear" styleClass="vgt-table condensed">
              <template slot="table-row" slot-scope="props">

              </template>
            </vue-good-table>                  </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
<!--    modals end-->

    <div class="card">
      <div class="row">
        <h5 class="title">Cash</h5>
        <div class="col-md-3">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.CashFloat)" id="float"
                   placeholder="Cash Float" required readonly>
            <label for="float">Float</label>
          </div>
        </div>

        <div v-if="viewCashupDetails" class="col-md-3">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.Cashrequired)" id="cash-required"
                   placeholder="Cash Required" required readonly>
            <label for="cash-required">Required</label>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.Cashdeclared)" id="cash-declared"
                   placeholder="Cash Declared" required readonly>
            <label for="cash-declared">Declared</label>
          </div>
        </div>

        <div v-if="viewCashupDetails" class="col-md-3">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.Cashdifference)" id="cash-difference"
                   placeholder="Cash Declared" :style="colorCash" readonly>
            <label for="cash-difference">Difference</label>
          </div>
        </div>
      </div>
      <div class="row">
        <h5 class="title">Card</h5>
        <div v-if="viewCashupDetails" class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.Cardrequired)" id="card-required"
                   placeholder="Card Required" required readonly>
            <label for="card-required">Required</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.Carddeclared)" id="card-declared"
                   placeholder="Card Declared" required readonly>
            <label for="card-declared">Declared</label>
          </div>
        </div>
        <div v-if="viewCashupDetails" class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.CardDifference)" id="card-difference"
                   placeholder="Card Difference" :style="colorCard" readonly>
            <label for="card-difference">Difference</label>
          </div>
        </div>
      </div>

      <div class="row" v-for="method in cashup.other">
        <h5 class="title">{{ method.name }}</h5>
        <div v-if="viewCashupDetails" class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(method.required,2,'.',`,`,true,method.currencySymbol)" :id="`${method.id}-required`"
                   :placeholder="`${method.name} Required`" required readonly>
            <label :for="`${method.id}-required`">Required</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(method.declared,2,'.',`,`,true,method.currencySymbol)" :id="`${method.id}-declared`"
                   :placeholder="`${method.name} Declared`" required readonly>
            <label :for="`${method.id}-declared`">Declared</label>
          </div>
        </div>
        <div v-if="viewCashupDetails" class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(method.difference,2,'.',`,`,true,method.currencySymbol)" :id="`${method.id}-difference`"
                   :placeholder="`${method.name} Difference`" :style="getMethodColor(method)" readonly>
            <label :for="`${method.id}-difference`">Difference</label>
          </div>
        </div>
      </div>

      <div class="row">
        <h5 class="title">Other payments</h5>
        <div class="col-md-3">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.LaybyPaid)" id="void-count"
                   placeholder="Layby paid" readonly>
            <label for="void-count">Layby paid</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.LaybySales)" id="voids-value"
                   placeholder="Voids Value" readonly>
            <label for="voids-value">Voids Value</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.Payouts)" id="ref-count"
                   placeholder="Payouts" readonly>
            <label for="ref-count">Payouts</label>
          </div>
        </div>
      </div>
      <div class="row">
        <h5 class="title">Combined (Cash + Card)</h5>
        <div v-if="viewCashupDetails" class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.Combinedrequired)" id="combined-required"
                   placeholder="Combined Required" required readonly>
            <label for="combined-required">Required</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.Combineddeclared)" id="combined-declared"
                   placeholder="Combined Declared" required readonly>
            <label for="combined-declared">Declared</label>
          </div>
        </div>
        <div v-if="viewCashupDetails" class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control"
                   :value="$utils.formatMoney(cashup.Combineddifference)" id="combined-difference"
                   placeholder="Card Difference" :style="colorCombined" readonly>
            <label for="combined-difference">Difference</label>
          </div>
        </div>
      </div>

    </div>
    <div class="text-center">
      <button :disabled="loading" class="btn-cashup" @click="confirmationText">
        <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <i class="fas fa-check-circle"></i> Finalize
      </button>

      <div class="action-buttons-container">
        <button class="btn btn-sales" data-bs-toggle="modal" data-bs-target="#accPaymentsModalVisible" data-bs-whatever="@mdo" @click="openSalesModal">
          <i class="fas fa-shopping-cart"></i> Sales
        </button>
        <button class="btn btn-items" data-bs-toggle="modal" data-bs-target="#cashToSafeModalVisible" data-bs-whatever="@mdo" @click="openSoldModal">
          <i class="fas fa-box"></i> Items
        </button>
        <button class="btn btn-voids" data-bs-toggle="modal" data-bs-target="#voidsModalVisible" data-bs-whatever="@mdo" @click="openVoidsModal">
          <i class="fas fa-ban"></i> Voids
        </button>
        <button class="btn btn-refunds" data-bs-toggle="modal" data-bs-target="#refunModalVisible" data-bs-whatever="@mdo" @click="openRefundsModal">
          <i class="fas fa-undo"></i> Refunds
        </button>
        <button class="btn btn-account" data-bs-toggle="modal" data-bs-target="#AccountspayVisible" data-bs-whatever="@mdo" @click="openAccountspay">
          <i class="fas fa-user-circle"></i> Account Payments
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {Storage} from "@/services/Storage";
import axios from "axios";
import { generateUUID } from "@/utils/uuid";
export default {
  name: "CashupSummary",
  props: {cashup: {type: Object, required: true}},
  data() {
    return {
      pageOptions: {
        enabled: true, // Enable pagination
        perPage: 10, // Number of items per page
        mode: 'records' // Pagination mode: 'records' or 'pages'
        // You can add more pagination options as needed
      },
      accPaymentsModalVisible: false,
      cashToSafeModalVisible: false,
      voidsModalVisible: false,
      refunModalVisible: false,
      AccountspayVisible: false,
      cashups: [],
      fsales: [],
      fsold: [],
      fvoids: [],
      fAccountsPay: [],
      frefunds: [],
      viewCashupDetails: false,
      loading: false,
      cashupLocalId: null,
      form: {
        user : null,
        date : null
      },
      modalViewRefunds: [
        {
          label: `Date`,
          field: `date`,
        },
        {
          label: `Invoice number`,
          field: `invnum`,
        },
        {
          label: `Payment Total`,
          field: `paymenttotal`,
        },
        {
          label: `Payment type`,
          field: `paymenttype`,
        },
        {
          label: `PC`,
          field: `pc`,
        },
        {
          label: `Sale Total`,
          field: `saletotal`,
        },
        {
          label: `User`,
          field: `user`,
          sortable: false,
        },
      ],
      modalColumns: [
        {
          label: 'Invoice#',
          field: 'name',
        },
        {
          label: 'User',
          field: 'age',
        },
        {
          label: 'Date',
          field: 'size',
        },
        {
          label: 'Payment Type',
          field: 'month',
        },
        {
          label: 'Total',
          field: 'day',
        },
        {
          label: 'PC',
          field: 'day',
        },
        {
          label: 'Action',
          field: 'day',
        },
      ],
      modalAccountspayVisible: [
        {
          label: 'User',
          field: 'user',
        },
        {
          label: 'payment-Type',
          field: 'paymentType',
        },
        {
          label: 'Description',
          field: 'description',
        },
        {
          label: 'DebtorName',
          field: 'debtorName',
        },
        {
          label: 'DebtorID',
          field: 'debtorID',
        },
        {
          label: 'Date',
          field: 'date',
        },
        {
          label: 'cashed up',
          field: 'cashedup',
        },
        {
          label: 'Amount',
          field: 'amount',
        },   ],
      modalColumnsviewPayouts: [
        {
          label: 'Reason',
          field: 'name',
        },
        {
          label: 'Date',
          field: 'age',
        },
        {
          label: 'Amount',
          field: 'size',
        },
        {
          label: 'Vat',
          field: 'month',
        },
        {
          label: 'User',
          field: 'day',
        },
        {
          label: 'PC',
          field: 'day',
        },
        {
          label: 'Supplier',
          field: 'day',
        },
        {
          label: 'Action',
          field: 'day',
        },      ],
      modalViewAccountspayments: [
        {
          label: 'Invoice Number',
          field: 'invnum',
        },
        {
          label: 'Payment Type',
          field: 'paymenttype',
        },
        {
          label: 'Pc',
          field: 'pc',
        },
        {
          label: 'Sale Total',
          field: 'saletotal',
        },
        {
          label: 'User',
          field: 'user',
        },
      ],
      modalViewCashToSale: [
        {
          label: 'PLU',
          field: 'PLU',
        },
        {
          label: 'Description',
          field: 'Description',
        },
        {
          label: 'Cost',
          field: 'cost',
        },

        {
          label: 'Profit',
          field: 'profit',
        },
        {
          label: 'Quantity',
          field: 'qty',
        },
        {
          label: 'Total',
          field: 'total',
        },      ],
      modalViewVoids: [
        {
          label: 'ID',
          field: 'Id',
        },
        {
          label: 'CashUp',
          field: 'CashUp',
        },
        {
          label: 'Date Time',
          field: 'DateTime',
        },
        {
          label: 'Pc',
          field: 'PC',
        },
        {
          label: 'Reason',
          field: 'Reason',
        },
        {
          label: 'Super Visor',
          field: 'SuperVisor',
        },
        {
          label: 'User',
          field: 'User',
        },
        {
          label: 'Description',
          field: 'VoidDescriptiom',
        },
        {
          label: 'number',
          field: 'VoidNum',
        },
        {
          label: 'PLU',
          field: 'VoidPlu',
        },
        {
          label: 'Quantity',
          field: 'VoidQty',
        },
        {
          label: 'Value',
          field: 'VoidValue',
        },
        {
          label: 'Department',
          field: 'department',
        },

      ],
      modalViewCredits: [
        {
          label: 'Debtor',
          field: 'name',
        },
        {
          label: 'Old Invoice',
          field: 'age',
        },
        {
          label: 'New Invoice',
          field: 'size',
        },
        {
          label: 'Date',
          field: 'month',
        },
        {
          label: 'User',
          field: 'day',
        },
        {
          label: 'PC',
          field: 'day',
        },
        {
          label: 'Amount',
          field: 'day',
        },
        {
          label: 'Action',
          field: 'day',
        },      ],
    }
  },
  computed: {
    colorCash() {
      let val = this.cashup.Cashdifference;
      let color = 'var(--danger)';
      if (val === 0) {
        color = 'var(--success)';
      } else if (val > 0) {
        color = 'var(--warning)';
      }
      return {color: color};
    },

    colorCard() {
      let val = this.cashup.CardDifference;
      let color = 'var(--danger)';
      if (val === 0) {
        color = 'var(--success)';
      } else if (val > 0) {
        color = 'var(--warning)';
      }
      return {color: color};
    },

    colorCombined() {
      let val = this.cashup.Combineddifference;
      let color = 'var(--danger)';
      if (val === 0) {
        color = 'var(--success)';
      } else if (val > 0) {
        color = 'var(--warning)';
      }
      return {color: color};
    },
  },
  methods: {
    confirmationText(){
      return Swal.fire({
        title: 'Are you sure?',
        text: "Please make sure your figures are correct!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Yes, I am sure !`
      }).then((result) => {
        if (result.isConfirmed) {
          return this.finalize();
        }
      })
    },
    finalize() {
      let other = (this.cashup.other || []).map(method => ({
        id: method.id,
        amount: Number(method.declared)
      }));

      if (!this.cashupLocalId) {
        this.cashupLocalId = generateUUID();
      }

      let data = {
        cash: this.cashup.Cashdeclared,
        card: this.cashup.Carddeclared,
        user: this.cashup.User,
        PC: this.cashup.PC,
        other: other,
        localId: this.cashupLocalId,
      };
      return this.$store.dispatch('cashUpUser', data)
          .then(() => {
            this.cashupLocalId = null;
            return this.$store.dispatch("posLogout");
          })
          .finally(() => this.$utils.hideLoading())
    },

    getMethodColor(paymentMethod){
      const diff = paymentMethod.difference;
      let color = 'var(--success)';
      if (diff > 0){
        color = 'var(--warning)';
      }

      if (diff < 0){
        color = 'var(--danger)';
      }
      return { color : color }
    },
    openSalesModal() {
      this.fetchsales(); // Fetch sales data
      this.accPaymentsModalVisible = true; // Show sales modal
    },
    openSoldModal() {
      this.fetchSold(); // Fetch sold data
      this.cashToSafeModalVisible = true; // Show sold modal
    },
    openVoidsModal() {
      this.fetchVoids(); // Fetch voids data
      this.voidsModalVisible = true; // Show voids modal
    },
    openRefundsModal() {
      this.fetchRefunds(); // Fetch refunds data
      this.refunModalVisible = true; // Show refunds modal
    },

    openAccountspay() {
      this.fetchAccountsPay(); // Fetch refunds data
      this.AccountspayVisible = true; // Show refunds modal
    },
    async fetchsales() {
      let store = await Storage.getDefaultStore();
      let settings   = await Storage.getDeviceSettings();
      this.device = settings.PC;
      let user  = await Storage.getCurrentUser();
      this.userName = user.Username;
      const db = window.btoa(store.StoreDB)
      const headers = { DB: db };
      const apiUrl = `${reportsApi}getPreCashupSales?user=${this.userName}&pc=${this.device}`;
      axios.get(apiUrl,{headers:headers})
          .then(({data}) => {
            this.fsales = data;
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
    },

    async fetchSold() {
      let store = await Storage.getDefaultStore();
      let settings   = await Storage.getDeviceSettings();
      this.device = settings.PC;
      let user  = await Storage.getCurrentUser();
      this.userName = user.Username;
      const db = window.btoa(store.StoreDB)
      const headers = { DB: db };
      const apiUrl = `${reportsApi}getProductsSoldPreCashup?user=${this.userName}&pc=${this.device}`;
      axios.get(apiUrl,{headers:headers})
          .then(({data}) => {
            this.fsold = data;
          })
          .catch ((error) => {
            console.error("Error fetching data from API:", error);
          });
    },

    async fetchVoids() {
      let store = await Storage.getDefaultStore();
      let settings   = await Storage.getDeviceSettings();
      this.device = settings.PC;
      let user  = await Storage.getCurrentUser();
      this.userName = user.Username;
      const db = window.btoa(store.StoreDB)
      const headers = { DB: db };
      const apiUrl = `${reportsApi}getPreCashupVoids?user=${this.userName}&pc=${this.device}`;
      axios.get(apiUrl,{headers:headers})
          .then(({data}) => {
            this.fvoids = data;
          })
          .catch ((error) => {
            console.error("Error fetching data from API:", error);
          });
    },

    async fetchAccountsPay() {
      let store = await Storage.getDefaultStore();
      let settings   = await Storage.getDeviceSettings();
      this.device = settings.PC;
      let user  = await Storage.getCurrentUser();
      this.userName = user.Username;
      const db = window.btoa(store.StoreDB)
      const headers = { DB: db };
      const apiUrl = `${reportsApi}getPreCashupAccountPayments?pc=${this.device}&user=${this.userName}`;
      axios.get(apiUrl,{headers:headers})
          .then(({data}) => {
            this.fAccountsPay = data;
          })
          .catch ((error) => {
            console.error("Error fetching data from API:", error);
          });
    },

    async fetchRefunds() {
      let store = await Storage.getDefaultStore();
      let settings   = await Storage.getDeviceSettings();
      this.device = settings.PC;
      let user  = await Storage.getCurrentUser();
      this.userName = user.Username;
      const db = window.btoa(store.StoreDB)
      const headers = { DB: db };
      const apiUrl = `${reportsApi}getPreCashupRefunds?user=${this.userName}&pc=${this.device}`;
      axios.get(apiUrl,{headers:headers})
          .then(({data}) => {
            this.frefunds = data;
          }).catch ((error) =>{
        console.error("Error fetching data from API:", error);
      });
    },

    async checkViewCashupDetailsPermission() {
      try {
        const hasPermission = await this.$store.dispatch('validateSecurityPermissionNoPrompt', 'viewCashupDetails');

        this.viewCashupDetails = hasPermission;
      } catch (error) {
        console.error('Error checking security permission:', error);
        this.viewCashupDetails = false;
      }
    }
  },
  mounted() {
    this.checkViewCashupDetailsPermission();
  }
}
</script>
<style lang="scss" scoped>
.container-fluid {
  height: 100%;
  overflow-y: auto;
  padding: 24px 16px;
  background: var(--bg-gradient);
  font-family: var(--font-family);
  width: 100%;
  max-width: 100%; // Add this
  box-sizing: border-box; // Add this
}

.card {
  background: var(--card-bg);
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  border: var(--card-border);
  padding: 24px;
  margin-bottom: 24px;
  transition: var(--transition-speed);
  animation: fadeIn 0.5s ease;
  width: 100%;
  max-width: 100%; // Add this
  box-sizing: border-box; // Add this

  &:hover {
    box-shadow: var(--card-shadow-hover);
  }

  .row {
    margin-bottom: 24px;
    position: relative;
    padding-top: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    .title {
      font-size: 1.1rem;
      font-weight: 600;
      color: var(--text-primary);
      margin-bottom: 12px;
      padding-left: 8px;
      border-left: 3px solid var(--accent-electric-blue);
      position: absolute;
      top: -8px;
      left: 12px;
      background: var(--card-bg);
      padding: 0 8px;
    }

    .form-floating {
      margin-bottom: 16px;

      .form-control {
        height: 50px;
        padding: 1rem 0.75rem;
        font-size: 1rem;
        border: var(--card-border);
        border-radius: 8px;
        background-color: var(--bg-primary);
        color: var(--text-primary);
        transition: var(--transition-speed);

        &:focus {
          border-color: var(--accent-electric-blue);
          box-shadow: 0 0 0 0.2rem rgba(51, 156, 255, 0.25);
          outline: none;
        }
      }

      label {
        padding: 0.75rem 0.75rem;
        color: var(--text-secondary);
      }
    }
  }
}

.col-md-4, .col-md-3 {
  margin-bottom: 16px;
}

.btn-cashup {
  background: linear-gradient(135deg, var(--accent-electric-blue), var(--accent-neon-purple));
  color: var(--text-on-accent);  /* theme token: replaces hardcoded #fff on accent gradient — TicketApp #26670 */
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 32px;
  min-width: 250px;
  height: 50px;
  margin-bottom: 16px;
  border-radius: 8px;
  border: none;
  transition: var(--transition-speed);
  box-shadow: var(--card-shadow);
  font-size: 1.1rem;

  &:hover:not(:disabled) {
    box-shadow: var(--card-shadow-hover);
    transform: translateY(-2px);
  }

  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
}

.btn-primary {
  background-color: var(--accent-electric-blue);
  border-color: var(--accent-electric-blue);
  color: var(--text-on-accent);  /* theme token: replaces hardcoded #fff on accent blue — TicketApp #26670 */
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  transition: var(--transition-speed);
  margin-right: 8px;
  margin-bottom: 16px;
  box-shadow: var(--card-shadow);

  &:hover {
    background-color: var(--accent-electric-blue-dark);
    border-color: var(--accent-electric-blue-dark);
    transform: translateY(-2px);
    box-shadow: var(--card-shadow-hover);
  }
}

.text-center {
  text-align: center;
}

// Modal styling
.modal-content {
  background: var(--card-bg);
  border-radius: 12px;
  border: var(--card-border);
  box-shadow: var(--card-shadow-hover);

  .modal-header {
    border-bottom: var(--card-border);
    padding: 16px 24px;

    .modal-title {
      color: var(--text-primary);
      font-weight: 600;
    }

    .btn-close {
      color: var(--text-primary);
      opacity: 0.7;
      transition: var(--transition-speed);

      &:hover {
        opacity: 1;
      }
    }
  }

  .modal-body {
    padding: 24px;
  }

  .modal-footer {
    border-top: var(--card-border);
    padding: 16px 24px;

    .btn-secondary {
      background-color: var(--secondary-button-bg);
      color: var(--secondary-button-text);
      border: none;
      padding: 8px 16px;
      border-radius: 8px;
      transition: var(--transition-speed);

      &:hover {
        background-color: var(--secondary-button-bg-dark);
      }
    }
  }
}

// Vue Good Table cashup modal styling.
//
// SCOPED CSS PENETRATION + POLAR-BEAR + BORDERED SPECIFICITY: this CashupSummary.vue
// component also uses `theme="polar-bear"` and inherits the default `bordered`
// styleClass, so the rendered `<table>` element carries BOTH classes. vue-good-table's
// compiled CSS ships `.vgt-table.polar-bear.bordered td { background: #fff }` at
// specificity (0,3,1) — the previous fix used `:deep(.vgt-table)` at (0,2,0) and
// `:deep(.vgt-table) td` at (0,2,1), which lost to polar-bear's higher-specificity
// rule. Result: cashup summary data rows rendered white-on-white from the polar-bear
// default even with `!important`. The fix below explicitly targets
// `.vgt-table.polar-bear` AND `.vgt-table.polar-bear.bordered` so specificity
// matches or beats the override it replaces.
//
// VISIBLE CONTRAST: previous fix used `var(--secondary-button-bg)` (= --bg-secondary)
// for headers but gave td no explicit background, letting the table's #FFFFFF show
// through. New fix uses `--bg-primary` for the table body and zebra stripes odd rows
// with `--bg-secondary`, so the data card visibly contrasts with the modal body's
// `--card-bg` in BOTH themes (light: #FFFFFF vs #F8FAFC, dark: #0D0B33 vs #1A1840).
:deep(.vgt-table.polar-bear) {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border-default) !important;
  border-radius: 8px !important;
  border-bottom: 1px solid var(--border-default) !important;
  font-family: var(--font-family);

  thead th {
    background: var(--bg-secondary) !important;
    color: var(--text-primary) !important;
    font-weight: 600;
    padding: 14px 16px;
    text-align: left;
    border-bottom: 1px solid var(--border-default) !important;
    font-size: 0.9rem;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  // Zebra-striped data rows so the table structure is unambiguous and no row can
  // be mistaken for an empty/blank row. Works in both light and dark modes because
  // --bg-secondary resolves to a visible gray in each.
  tbody tr {
    background: var(--bg-primary) !important;

    &:nth-of-type(odd) {
      background: var(--bg-secondary) !important;
    }

    // Accent-blue hover with high-contrast text — universal POS interaction signal.
    &:hover {
      background: var(--accent-electric-blue) !important;
      cursor: pointer;

      td {
        color: var(--text-on-accent) !important;
      }
    }
  }

  // Force td to inherit the tr background (so stripe/hover are visible) and use
  // the theme text token instead of polar-bear's hardcoded #525f7f.
  td {
    background: transparent !important;
    padding: 14px 16px;
    border-bottom: 1px solid var(--border-default) !important;
    color: var(--text-primary) !important;
    font-size: 0.95rem;
  }
}

// Bordered-variant override — matches vue-good-table's compiled CSS at equal
// specificity with `!important` so the polar-bear `.bordered td { background:#fff }`
// rule no longer wins.
:deep(.vgt-table.polar-bear.bordered) {
  td {
    background: transparent !important;
    color: var(--text-primary) !important;
    border: 1px solid var(--border-default) !important;
  }

  th {
    background: var(--bg-secondary) !important;
    color: var(--text-primary) !important;
  }
}

// Animations
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Action buttons styling
.action-buttons-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 16px;
  max-width: 800px;
  margin: 0 auto;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 500;
  transition: var(--transition-speed);
  box-shadow: var(--card-shadow);
  border: none;
  color: var(--text-on-accent);  /* theme token: replaces hardcoded #fff; variants (.btn-sales, .btn-items, .btn-voids) provide accent backgrounds — TicketApp #26670 cashup items invisible */

  i {
    margin-right: 8px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--card-shadow-hover);
  }
}

.btn-sales {
  background: var(--success);

  &:hover {
    background: var(--success-dark);
  }
}

.btn-items {
  background: var(--accent-neon-purple);

  &:hover {
    background: var(--accent-neon-purple-dark);
  }
}

.btn-voids {
  background: var(--danger);

  &:hover {
    background: darken(#FF3B30, 10%);
  }
}

.btn-refunds {
  background: var(--warning);

  &:hover {
    background: var(--accent-orange-dark);
  }
}

.btn-account {
  background: var(--accent-electric-blue);
  grid-column: span 2;

  &:hover {
    background: var(--accent-electric-blue-dark);
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .container {
    padding: 16px;
  }

  .card {
    padding: 16px;
  }

  .btn-cashup {
    width: 100%;
    margin-right: 0;
  }

  .action-buttons-container {
    grid-template-columns: 1fr;
  }

  .btn-account {
    grid-column: auto;
  }
}
</style>
